// gatsby libraries
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// @material-ui/core icons
// page sections
import customHeaderStyle from 'assets/jss/material-kit-pro-react/components/customHeaderStyle.jsx';
import Header from 'components/Header/Header.jsx';
import HeaderLinks from 'components/Header/HeaderLinks.jsx';
// component styles
import { useStaticQuery, graphql } from 'gatsby';
import React from 'react';

const useStyles = makeStyles(customHeaderStyle);

export default function CustomHeader({ ...rest }) {
  // eslint-disable-next-line no-unused-vars
  const classes = useStyles();
  const { lightLogo, darkLogo } = useStaticQuery(graphql`
    query getCustomHeaderImages {
      lightLogo: file(
        relativePath: { eq: "logos/chilimania-logo-transparent-white.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
        }
      }
      darkLogo: file(
        relativePath: { eq: "logos/chilimania-logo-transparent.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
        }
      }
    }
  `);
  return (
    <div>
      {/* <SnackbarContent
        message={
          <span>
            Online ticket sales are closed. GA tickets are still available at
            the gate.
          </span>
        }
        close
        color="danger"
        icon={NotificationsIcon}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      /> */}
      <Header
        color="transparent"
        brand="Chilimania"
        logoImageLight={lightLogo.childImageSharp.gatsbyImageData}
        logoImageDark={darkLogo.childImageSharp.gatsbyImageData}
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        changeColorOnScroll={{
          height: 10,
          color: 'white',
        }}
        {...rest}
      />
    </div>
  );
}
